import { Checkbox, FormControlLabel } from '@mui/material';
import { type Control, Controller, type FieldPath, type FieldValues } from 'react-hook-form';

export interface RememberMeCheckboxProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
}

/**
 * UX-only today: the platform doesn't yet persist a session across a hard reload (no `HttpOnly`
 * refresh cookie set by the backend — `AuthContext`'s own doc comment tracks this gap), so this
 * checkbox has nothing to opt into on the client side. Kept as a real form field rather than
 * omitted so the login form's shape matches the design, without inventing storage behavior the
 * backend doesn't support yet.
 */
export function RememberMeCheckbox<T extends FieldValues>({
  name,
  control,
}: RememberMeCheckboxProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(field.value)}
              onChange={(e) => field.onChange(e.target.checked)}
            />
          }
          label="Remember me"
        />
      )}
    />
  );
}
